import { inject, Injectable, signal } from '@angular/core';
import { ResellerService } from '../../core/services';
import { map, Observable, switchMap, tap } from 'rxjs';
import { HttpResponse } from '@angular/common/http';

@Injectable({
	providedIn: 'root'
})
export class ThemeService {
	private resellerService = inject(ResellerService);

	brandColor = signal('');
	baseColor = '#D10000';

	constructor() {}

	setBrandingByUserId(userId: number): void {
		this.resellerService
			.getResellerByUserId(userId)
			.pipe(
				tap(reseller => {
					// Se ha brandColor, lo setto
					if (reseller.brandColor && reseller.brandColor !== '') {
						this.brandColor.set(reseller.brandColor);
						document.documentElement.style.setProperty(
							'--primary-color',
							this.brandColor()
						);
					}
				}),
				switchMap(reseller => {
					return this.resellerService
						.getImageBlobByResellerIdAndType(reseller.resellerId, 'favicon')
						.pipe(map((response: HttpResponse<Blob>) => response.body));
				}),
				tap(blob => {
					if (blob) {
						const url = URL.createObjectURL(blob);
						this.setFavicon(url);
					}
				})
			)
			.subscribe();
	}

	setBrandingByResellerUrl(resellerUrl: string): Observable<void> {
		return this.resellerService.getResellerByUserUrl(resellerUrl).pipe(
			tap(res => {
				if (res.data) {
					// Imposta il brandColor
					this.brandColor.set(res.data);
					document.documentElement.style.setProperty(
						'--primary-color',
						this.brandColor()
					);
				} else {
					// Fallback se non c'è brandColor
					this.resetBaseColor();
				}
			}),
			switchMap(() =>
				this.resellerService
					.getImageBlobByResellerUrlAndType(resellerUrl, 'favicon')
					.pipe(map(response => response.body))
			),
			tap(blob => {
				if (blob) {
					const url = URL.createObjectURL(blob);
					this.setFavicon(url);
				} else {
					// Fallback se non c'è favicon
					this.resetDefaultFavicon();
				}
			}),
			map(() => void 0)
		);
	}

	private setFavicon(faviconUrl: string) {
		let link: HTMLLinkElement | null =
			document.querySelector("link[rel~='icon']");
		if (!link) {
			link = document.createElement('link');
			link.rel = 'icon';
			document.head.appendChild(link);
		}
		link.href = faviconUrl;
	}

	resetBaseColor() {
		document.documentElement.style.setProperty(
			'--primary-color',
			this.baseColor
		);
	}

	resetDefaultFavicon() {
		let link: HTMLLinkElement | null =
			document.querySelector("link[rel~='icon']");
		if (!link) {
			link = document.createElement('link');
			link.rel = 'icon';
			document.head.appendChild(link);
		}
		link.href = 'images/logo-dark.png';
	}
}
